import { render } from "./CobraPayments.vue?vue&type=template&id=c7682b9a&ts=true"
import script from "./CobraPayments.vue?vue&type=script&lang=ts"
export * from "./CobraPayments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__